var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-medium well m-auto mt-8 pt-5 px-5 pb-0" },
    _vm._l(_vm.settings, function(setting, indexSetting) {
      return _c(
        "div",
        {
          key: indexSetting,
          staticClass:
            "dinlineb valign-top span_3 px-6 pb-6 clear-first-last-space col-4"
        },
        [
          _c("h3", { staticClass: "mt-0 pb-1 bb-1" }, [
            _vm._v(_vm._s(setting.label))
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "m-0" },
            _vm._l(setting.sub, function(sub, indexSub) {
              return _c(
                "li",
                { key: indexSub, staticClass: "settings-home__list" },
                [
                  sub.vueRouting
                    ? _c(
                        "router-link",
                        { staticClass: "black-link", attrs: { to: sub.url } },
                        [_vm._v("\n                    " + _vm._s(sub.label))]
                      )
                    : _c(
                        "a",
                        { staticClass: "black-link", attrs: { href: sub.url } },
                        [_vm._v(_vm._s(sub.label))]
                      ),
                  _vm._v(" "),
                  sub.flag
                    ? _c("CompassFlag", {
                        staticClass: "settings-home__flag",
                        attrs: {
                          label: sub.flag.label,
                          size: sub.flag.size,
                          beta: sub.flag.beta
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }